{
    "LinkInput_Title": "Titel",
    "LinkInput_URL": "URL",
    "LinkInput_Target": "Ziel",
    "LinkInput_NewTab": "In neuem Tab öffnen",
    "LinkInput_CurrentTab": "Im aktuellen Tab öffnen",
    "NAME": "LinkInputLanguage"
}